if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener('click', (event) => {
          const previousButton = event.target.closest('[data-modal-previous]');
          const nextButton = event.target.closest('[data-modal-next]');

          if (previousButton) {
            event.preventDefault();
            event.stopPropagation();
            this.showPreviousMedia();
          }

          if (nextButton) {
            event.preventDefault();
            event.stopPropagation();
            this.showNextMedia();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showPreviousMedia();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showNextMedia();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      getActiveMedia() {
        return this.querySelector('[data-media-id].active');
      }

      activateMedia(media) {
  if (!media) return;

  this.getMediaItems().forEach((item) => {
    item.classList.remove('active');

    const video = item.querySelector('video');
    if (video) {
      video.pause();
    }
  });

  media.classList.add('active');

if (media.nodeName === 'DEFERRED-MEDIA') {
  const template = media.querySelector('template');
  const templateVideo = template ? template.content.querySelector('video') : null;

  if (templateVideo) {
    templateVideo.muted = true;
    templateVideo.loop = true;
    templateVideo.autoplay = true;
    templateVideo.playsInline = true;
    templateVideo.controls = false;
    templateVideo.removeAttribute('controls');
  }

  media.loadContent();

  setTimeout(() => {
    const video = media.querySelector('video');

    if (video) {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('controls');

      video.play().catch(() => {});
    }
  }, 100);
}
}

      showPreviousMedia() {
        const items = this.getMediaItems();
        const active = this.getActiveMedia();

        if (!items.length || !active) return;

        const currentIndex = items.indexOf(active);
        const previousIndex =
          currentIndex <= 0 ? items.length - 1 : currentIndex - 1;

        this.activateMedia(items[previousIndex]);
      }

      showNextMedia() {
        const items = this.getMediaItems();
        const active = this.getActiveMedia();

        if (!items.length || !active) return;

        const currentIndex = items.indexOf(active);
        const nextIndex =
          currentIndex >= items.length - 1 ? 0 : currentIndex + 1;

        this.activateMedia(items[nextIndex]);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}